import type { ComponentType } from 'react';
import { Navigate, type RouteObject } from 'react-router';

const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

/**
 * Маршрути розділу «Навчання» (/kb/learning/…), шляхи відносні до /kb.
 * Сторінки й каркас із вкладками завантажуються ліниво.
 */
export const learningRoutes: RouteObject[] = [
  {
    path: 'learning',
    ...page(() => import('./LearningLayout')),
    children: [
      { index: true, ...page(() => import('./pages/MyLearningPage')) },
      { path: 'catalog', ...page(() => import('./pages/CatalogPage')) },
      // Без ідентифікатора — до каталогу (вкладка «Каталог» активна на сторінках курсу й уроку).
      { path: 'courses', element: <Navigate to="/kb/learning/catalog" replace /> },
      { path: 'courses/:courseId', ...page(() => import('./pages/CoursePage')) },
      { path: 'lessons', element: <Navigate to="/kb/learning/catalog" replace /> },
      { path: 'lessons/:lessonId', ...page(() => import('./pages/LessonPlayerPage')) },
      { path: 'lessons/:lessonId/edit', ...page(() => import('./pages/LessonEditorPage')) },
      { path: 'draft', ...page(() => import('./pages/DraftPage')) },
      { path: 'quizzes', ...page(() => import('./pages/QuizzesPage')) },
      { path: 'quizzes/new', ...page(() => import('./pages/QuizNewPage')) },
      { path: 'quizzes/:quizId', ...page(() => import('./pages/QuizPage')) },
      { path: 'review', ...page(() => import('./pages/ReviewPage')) },
      { path: 'import', ...page(() => import('./pages/ImportPage')) },
      { path: 'routes', ...page(() => import('./pages/RoutesPage')) },
      { path: 'enrollments', ...page(() => import('./pages/EnrollmentsPage')) },
      { path: 'admissions', ...page(() => import('./pages/AdmissionsPage')) },
      { path: 'log', ...page(() => import('./pages/TrainingLogPage')) },
      { path: 'guides', ...page(() => import('./pages/GuidesPage')) },
    ],
  },
];
